module.exports = Object.freeze({
  User: {
    typeAdmin: 'admin',
    typePartner: 'partner',
  },
  Service: {
    typePayment: 'payment',
    typeDigitalAccess: 'digitalAccess',
    typeCrossword: 'crossword',
    typeContest: 'contest',
    typeMessage: 'message',
    typeInfo: 'info',
    connectionTypeMicroPayments: 'micropayments',
    connectionTypePremium: 'premium',
  },
  ScheduleChange: {
    modelService: 'service',
    modelServiceOperator: 'serviceOperator',
  },
  Share: {
    typePartner: 'partner',
    typeOperator: 'operator',
    variantPrice: 'price',
    variantPercent: 'percent',
    transactionTypeVat: 'vat',
    transactionTypeMediatexFee: 'mediatex_fee',
    transactionTypeMediatexShare: 'mediatex_share',
    transactionTypeOperatorFee: 'operator_fee',
    transactionTypeOperatorShare: 'operator_share',
    transactionTypePartnerFee: 'partner_fee',
    transactionTypePartnerShare: 'partner_share',
  },
  TransactionShare: {
    typeInvestment: 'investment',
  },
})